import React from 'react';
import { ImageProps } from '.';

const SvgFastshipEmblem = ({ size = 51, ...props }: ImageProps): JSX.Element => {
  return (
    <svg width={size} height={(size && Math.floor(size / 4.25)) || 12} fill='none' viewBox='0 0 51 12' {...props}>
      <path
        fill='#3D4F6F'
        d='M22.968 4.772h.936v1.087h-.936v4.799h-1.28V1.325h1.28v3.446ZM41.709 6.259h-3.56v.584h2.553V9.12h-5.155v.513h5.4v.964h-6.671V8.238h5.145v-.461h-5.155v-.934h2.592V6.26H33.31v-.954h8.399v.954ZM49.63 8.956h-4.85v.604h5.114v1.036h-6.386V8.022h4.83v-.584h-4.85V6.423h6.142v2.533ZM26.65 9.448h5.277v1.046h-6.58V7.93h1.303v1.518ZM10.682 2.963c.242 0 .447.122.553.326l1.458 2.83a.521.521 0 0 1 .032.397l-.577 1.715a.39.39 0 0 1-.385.269h-.98c-.05 0-.094.03-.106.076-.372 1.004-1.303 1.71-2.11 1.71-.806 0-1.247-.66-.999-1.616.025-.094-.037-.17-.137-.17H4.887c-.05 0-.093.03-.105.076-.372 1.004-1.304 1.71-2.11 1.71-.807 0-1.247-.66-1-1.616.026-.094-.036-.17-.136-.17H.88c-.205 0-.33-.157-.267-.344l.415-1.255a.39.39 0 0 1 .385-.268h5.38c.285 0 .521-.157.608-.42l1-2.982a.39.39 0 0 1 .384-.268h1.898Z'
      />
      <path
        fill='#3D4F6F'
        fillRule='evenodd'
        d='M16.43 4.33h.59V2.169h1.058v6.336h-2.715V2.168h1.067V4.33Zm0 3.098h.59V5.367h-.59v2.06ZM19.501 4.33h.6V2.169h1.058v6.336h-2.706V2.168h1.048V4.33Zm0 3.098h.6V5.367h-.6v2.06Z'
        clipRule='evenodd'
      />
      <path
        fill='#3D4F6F'
        d='M32.75 7.417h-8.47V6.372h8.47v1.045ZM49.63 3.141h1.25v1.057h-1.25v1.876h-1.302V1.326h1.302v1.815Z'
      />
      <path
        fill='#3D4F6F'
        fillRule='evenodd'
        d='M43.854 2.855h1.892V1.747h1.301v4.07h-4.484v-4.07h1.291v1.108Zm0 1.938h1.892v-.954h-1.892v.954Z'
        clipRule='evenodd'
      />
      <path
        fill='#3D4F6F'
        d='M31.724 4.116h-5.095v.666h5.267v.984h-6.559V3.183h5.085v-.636h-5.105V1.542h6.407v2.574ZM6.737 4.165c.204 0 .329.157.267.344l-.317.946a.388.388 0 0 1-.385.267H.283c-.204 0-.33-.157-.267-.344l.317-.945a.389.389 0 0 1 .384-.268h6.02ZM38.14 2.055h2.776v.964h-2.613c.254.543 1.2.99 3.07 1.066l-.376.964c-1.718-.083-2.908-.523-3.498-1.23-.584.707-1.78 1.148-3.508 1.23l-.356-.964c1.856-.077 2.796-.523 3.06-1.066h-2.592v-.964h2.755v-.739h1.282v.739ZM7.556 1.714c.204 0 .328.157.266.344l-.316.946a.388.388 0 0 1-.385.268H3.398c-.204 0-.328-.157-.266-.344l.316-.945a.388.388 0 0 1 .385-.269h3.723Z'
      />
    </svg>
  );
};

export default SvgFastshipEmblem;
